import {Component, ContentChild, Input, TemplateRef} from '@angular/core';
import {JBMTableColumnAlignment, JBMTableColumnDef, JBMTableColumnType} from '../types';

@Component({
  selector: 'jbm-table-column',
  template: ''
})
export class JBMTableColumnComponent {
  @Input() name: string;
  @Input() header: string;
  @Input() iconClassname: string;
  @Input() className: string;
  @Input() IDName: string;
  @Input() tag: any;
  @Input() type: JBMTableColumnType | keyof typeof JBMTableColumnType | string;
  @Input() align: JBMTableColumnAlignment | keyof typeof JBMTableColumnAlignment | string;
  @Input() width: number | string;
  @Input() minWidth: number | string;
  @Input() maxWidth: number | string;
  @Input() visible: boolean | string;
  @Input() hideable: boolean | string;
  @Input() sortable: boolean | string;
  @Input() sorted: boolean | string;
  @Input() filterable: boolean | string;
  @Input() searchMinLength: number | string;
  @Input() moveable: boolean | string;
  @Input() sizeable: boolean | string;
  @Input() filterValues: any[];
  @Input() displayValues: any[];
  @Input() filterValue: string;

  @ContentChild(TemplateRef) template: TemplateRef<any>;

  toColumnDef(): JBMTableColumnDef {
    return {
      name: this.name,
      header: this.header,
      iconClassname: this.iconClassname,
      className: this.className,
      IDName: this.IDName,
      tag: this.tag,
      type: this.parseColumnType(this.type),
      align: this.parseAlignment(this.align),
      width: this.parseNumber(this.width),
      minWidth: this.parseNumber(this.minWidth),
      maxWidth: this.parseNumber(this.maxWidth),
      visible: this.parseBoolean(this.visible),
      hideable: this.parseBoolean(this.hideable),
      sortable: this.parseBoolean(this.sortable),
      sorted: this.parseBoolean(this.sorted),
      filterable: this.parseBoolean(this.filterable),
      searchMinLength: this.parseNumber(this.searchMinLength),
      moveable: this.parseBoolean(this.moveable),
      sizeable: this.parseBoolean(this.sizeable),
      filterValues: this.filterValues,
      displayValues: this.displayValues,
      filterValue: this.filterValue,
      template: this.template
    };
  }

  private parseColumnType(value: any): JBMTableColumnType | undefined {
    if(value===undefined || value===null || value==='') return undefined;
    if(typeof value==='number') return value;
    let key=value.toString() as keyof typeof JBMTableColumnType;
    if(JBMTableColumnType[key]!==undefined) return JBMTableColumnType[key] as any;
    let numericValue=Number(value);
    return isNaN(numericValue) ? undefined : numericValue;
  }

  private parseAlignment(value: any): JBMTableColumnAlignment | undefined {
    if(value===undefined || value===null || value==='') return undefined;
    if(typeof value==='number') return value;
    let key=value.toString() as keyof typeof JBMTableColumnAlignment;
    if(JBMTableColumnAlignment[key]!==undefined) return JBMTableColumnAlignment[key] as any;
    let numericValue=Number(value);
    return isNaN(numericValue) ? undefined : numericValue;
  }

  private parseBoolean(value: any): boolean | undefined {
    if(value===undefined || value===null || value==='') return undefined;
    if(typeof value==='boolean') return value;
    return value.toString().toLowerCase()!=='false';
  }

  private parseNumber(value: any): number | undefined {
    if(value===undefined || value===null || value==='') return undefined;
    let numericValue=Number(value);
    return isNaN(numericValue) ? undefined : numericValue;
  }
}
